(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    var detailsToClose = Array.prototype.slice
      .call(document.querySelectorAll('details[data-auto-close-details][open]'))
      .filter(function (element) {
        var closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        var autoClose = element.getAttribute('data-auto-close-details');
        return (
          autoClose &&
          autoClose.indexOf(closingOn) !== -1 &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      });

    for (var i = 0; i < detailsToClose.length; i++) detailsToClose[i].removeAttribute('open');
  });
})();
